import { ColorScaleInterpolate, ColorScaleStep } from '@/utils/colorScale'
import { Limits } from './limits'
import { ChartComponent } from '..'
import { Orientation } from './lines'

export const createBackgroundGradient = (
  colorScale: ColorScaleInterpolate | ColorScaleStep,
  limits: Limits,
  orientation: Orientation,
  opacity?: number
): ChartComponent<'line'>[] => {
  const cs = {
    ...colorScale,
    orientation,
    cutoffs: colorScale.cutoffs.map((cutoff) => ({ ...cutoff, opacity }))
  }
  return [
    {
      type: 'line',
      xLimits: limits.x,
      yLimits: limits.y,
      gradient: {
        fill: cs
      },
      values: [
        [limits.x[0], limits.y[0]],
        [limits.x[1], limits.y[0]],
        [limits.x[1], limits.y[1]],
        [limits.x[0], limits.y[1]]
      ]
    }
  ]
}
